export const FETCH_USER_REQUEST='FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS='FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE= 'FETCH_USER_FAILURE';